import { useQuery } from '@tanstack/react-query';

import { LocationKey } from './keys';
import { LocationService } from './locationService';

export function useGetLocation(id?: number, enabled = true) {
  return useQuery({
    queryKey: [LocationKey.LOCATIONS, id],
    queryFn: () => LocationService.getLocation(id).then((response) => response.data),
    enabled: enabled && !!id,
  });
}
